export default function AboutDesc() {
    return (
        <div className="aboutDesc">
            <p>Mes Compétences</p>
            <h1>Laissez-moi vous parler de mes <span>Compétences & Expérience</span></h1>
            <p>Je m'efforce de développer diverses compétences en développement web afin de renforcer ma contribution aux projets.</p>
        </div>
    );
}